import { h } from 'preact';
import { useState, useEffect } from 'preact/hooks';

export function useAlert() {

    const [message, setMessage] = useState(null);
    const [status, setStatus] = useState(null);
    const [location, setLocation] = useState(null);

    const getClassName = () => {
        let str = "mb-2 text-sm";
        if (status === "error") {
            str += " text-red";
        }
        return str;
    }

    const renderAlert = () => {
        return <div className={getClassName()}>
            {message}
            { location ? <strong>{location}</strong> : null}
        </div>
    }

    const setAlert = (message, location = null, status = "notice") => {
        setMessage(message);
        setStatus(status);
        setLocation(location);
    }

    return [renderAlert, setAlert];

}
